<div class="mx-auto px-6 py-8 max-w-7xl">
  <h1 class="text-5xl! font-bold mb-12! text-gray-800">Create Topic</h1>
  <app-new-topic-form />
</div>
